<template>
    <div class="custom-number-input">
      <button class="increment-btn" @click="decrement">-</button>
      <input
        type="text"
        :value="displayValue"
        @input="onInput"
        class="cantidad-input"
      />
      <button class="increment-btn" @click="increment">+</button>
    </div>
  </template>
  
  
  <script>
  export default {
    props: {
      value: {
        type: Number,
        default: 0,
      }
    },
    computed: {
      displayValue() {
        return this.value;
      }
    },
    methods: {
      onInput(event) {
        const inputValue = parseFloat(event.target.value);
        if (!isNaN(inputValue)) {
          this.$emit("input", inputValue); // Emite el valor decimal ingresado manualmente
          this.$emit("cambio", inputValue); // Emite un evento "cambio" en cada modificación
        }
      },
      increment() {
        this.$emit("input", parseFloat(this.value) + 1); // Suma 1 al valor actual
        this.$emit("cambio", parseFloat(this.value) + 1); // Emite el nuevo valor
      },
      decrement() {
        this.$emit("input", Math.max(0, parseFloat(this.value) - 1)); // Resta 1 al valor actual
        this.$emit("cambio", Math.max(0, parseFloat(this.value) - 1)); // Emite el nuevo valor
      }
    }
  };
  </script>
  <style scoped>
  .custom-number-input {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px; /* Espacio entre los botones y el input */
  }
  
  .cantidad-input {
    width: 5em; /* Hace que el input sea más corto */
    text-align: center; /* Centra el texto dentro del input */
    font-size: 1.2em; /* Aumenta el tamaño de la fuente */
    padding: 0.2em 0.5em; /* Ajusta el relleno interno */
    border: 1px groove darkgrey;
    border-radius: 7px; /* Redondea las esquinas */
  }
  
  .increment-btn {
    font-size: 1.2em; /* Aumenta el tamaño del texto de los botones */
    width: 2em; /* Anchura de los botones */
    height: 2em; /* Altura de los botones */
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #4A90E2; /* Color de fondo de los botones */
    color: rgb(255, 255, 255); /* Color del texto en los botones */
    border: none; /* Quita los bordes */
    border-radius: 7px; /* Redondea las esquinas */
    cursor: pointer; /* Cambia el cursor al pasar el mouse */
    transition: background-color 0.2s; /* Transición para el efecto hover */
  }
  
  .increment-btn:hover {
    background-color: #357ABD; /* Color de fondo al pasar el mouse */
  }
  </style>
  